// Lightweight scoped logger for failures that used to be swallowed by
// `catch {}`. Keeps the failure visible in the console without changing
// behavior (fire-and-forget calls stay fire-and-forget).
export default function logError(scope, err) {
  // eslint-disable-next-line no-console
  console.warn(`[${scope}]`, err);
}
